/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { forwardRef, useImperativeHandle } from 'react';
import useSnackbar from 'src/hooks/useCustomSnackbar';
import { DentallyTreatmentAndAvailability } from './index';

/**
 * Wizard step wrapper for DentallyTreatmentAndAvailability.
 * Validates that a treatment and slot are selected before advancing.
 *
 * Used by both CreateLeadDialogWrapper and the Follow-Up wizard (NewLead.jsx).
 */
const DentallyTreatmentAvailabilityWizardStep = forwardRef((
    { handleNext: onSubmit, practiceId, dentallySlot, onSlotSelected, selectedDentallyTreatment, onTreatmentSelected, assignees, onAssigneesChanged, availSearchState, onAvailSearchStateChange },
    ref
) => {
    const { enqueueSnackbar } = useSnackbar();
    useImperativeHandle(ref, () => ({
        submit() {
            const missing = [];
            if (!selectedDentallyTreatment) missing.push('Treatment');
            if (!dentallySlot) missing.push('Appointment slot');
            if (missing.length) {
                enqueueSnackbar(`Please select: ${missing.join(', ')}`, {
                    variant: 'warning',
                    anchorOrigin: { vertical: 'top', horizontal: 'center' },
                });
                return;
            }
            onSubmit(dentallySlot);
        },
    }), [selectedDentallyTreatment, dentallySlot, onSubmit, enqueueSnackbar]);

    return (
        <DentallyTreatmentAndAvailability
            practiceId={practiceId}
            selectedSlot={dentallySlot}
            onSlotSelected={onSlotSelected}
            selectedDentallyTreatment={selectedDentallyTreatment}
            onTreatmentSelected={onTreatmentSelected}
            assignees={assignees}
            onAssigneesChanged={onAssigneesChanged}
            availSearchState={availSearchState}
            onAvailSearchStateChange={onAvailSearchStateChange}
        />
    );
});

export default DentallyTreatmentAvailabilityWizardStep;
